import { render } from "./Cardcategorie.vue?vue&type=template&id=266f1f3a"
import script from "./Cardcategorie.vue?vue&type=script&lang=js"
export * from "./Cardcategorie.vue?vue&type=script&lang=js"

import "./Cardcategorie.vue?vue&type=style&index=0&id=266f1f3a&lang=css"

import exportComponent from "D:\\fclinique\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__